import { Checkbox } from 'components/form/checkbox';
import React from 'react';
import { components } from 'react-select';
const Option = (props) => {
    const { data, isSelected } = props;
    return (React.createElement(components.Option, Object.assign({}, props),
        React.createElement(Checkbox, { onChange: (e) => {
                e.preventDefault();
                e.stopPropagation();
            }, checked: isSelected }, data.label)));
};
Option.displayName = 'SelectMultiple.Option';
export default Option;
